import React, { useState } from "react";

const KS2SectionATemporaryRateReduction = (props) => {
  const { setTemporaryRateReductionData, kiviMemberNo, savingSuspension } = props;
  const [temporaryRateReduction, setTemporaryRateReduction] = useState("");

  const handleTemporaryRateReductionChange = (e) => {
    const value = e.target.value;
    setTemporaryRateReduction(value);
    setTemporaryRateReductionData(value);
  };

  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number">3.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className=" col-md-5 yes-no-label">
              <label className="">Are you on a temporary rate reduction?</label>
            </div>

            <div className="section-form-group yes-no-box col-md-7">
              <div className="section-form-group-inline">
                <div className="form-check form-check-inline mb-1">
                  <input
                    type="radio"
                    id="temporary_rate_yes"
                    name="temporaryRateReduction"
                    value="yes"
                    checked={temporaryRateReduction === "yes"}
                    onChange={handleTemporaryRateReductionChange}
                    //className="form-check-input"
                    disabled={kiviMemberNo === "no" || savingSuspension === "no"}
                    style={{ transform: "scale(1.5)", marginRight: "8px" }}
                  />
                  <label htmlFor="temporary_rate_yes" className="form-check-label mb-0">Yes. See note over the page</label>
                </div>
              </div>
              <div className="section-form-group-inline">
                <div className="form-check form-check-inline mb-1 ">
                  <input
                    type="radio"
                    id="temporary_rate_no"
                    name="temporaryRateReduction"
                    value="no"
                    checked={temporaryRateReduction === "no"}
                    onChange={handleTemporaryRateReductionChange}
                    //className="form-check-input"
                    disabled={kiviMemberNo === "no" || savingSuspension === "no"}
                    style={{ transform: "scale(1.5)", marginRight: "8px" }}
                  />
                  <label htmlFor="temporary_rate_no" className="form-check-label mb-0">No. Go to Question 4</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default KS2SectionATemporaryRateReduction;
